/**
 * Optional **same-origin** email/SMS via `server.js` when SMTP / Twilio env vars are set.
 * Vite dev proxies `/api` → `server.js` (see `vite.config.ts`).
 */
export type ServerNotifyEmailBody = {
  to: string;
  subject: string;
  text?: string;
  html?: string;
};

export type ServerNotifySmsBody = {
  to: string;
  body: string;
};

export async function postServerEmail(
  body: ServerNotifyEmailBody
): Promise<{ ok: boolean; code?: string }> {
  const res = await fetch('/api/notify/email', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = (await res.json().catch(() => ({}))) as { ok?: boolean; code?: string };
  return { ok: !!data.ok, code: data.code };
}

export async function postServerSms(
  body: ServerNotifySmsBody
): Promise<{ ok: boolean; code?: string }> {
  const res = await fetch('/api/notify/sms', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = (await res.json().catch(() => ({}))) as { ok?: boolean; code?: string };
  return { ok: !!data.ok, code: data.code };
}
